export default __webpack_public_path__ + "static/media/rpg-7.68bdaa42.svg";